import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { SYNC_STOCKX_PRODUCT_IDS } from '../configurations/configApi';
import { apiGet } from '../apiActions/action';
import { Modal, Backdrop, CircularProgress } from '@material-ui/core/';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #eee',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: 400,
    position: 'relative'
  },
  item: {
    display: 'flex',
    flexDirection: 'column'
  },
  label: {
    width: '100%',
    marginTop: '.5rem'
  },
  loading: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: -16,
    marginLeft: -32,
    borderradius: 5,
    backgroundColor: 'white',
    opacity: 0.5,
    zIndex: 999
  }
}));

const SyncStockxIDModal = ({ productId, handleClose }) => {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState();

  const handleSubmitUrl = () => {
    setLoading(true);
    apiGet(
      SYNC_STOCKX_PRODUCT_IDS,
      {
        product_id: productId,
        product_url: url
      },
      ({ status, response }) => {
        setLoading(false);
        handleClose(status);
      }
    );
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={true}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <div className={classes.paper}>
          {loading && (
            <div className={classes.loading}>
              <CircularProgress color="inherit" size={20} />
            </div>
          )}
          <div className={`${classes.item} input-group mb-2`}>
            <label
              for="stockx_product_url"
              className={classes.label}
            >
              Stockx Product URL:&nbsp;
            </label>
            <input
              className="form-control"
              style={{ width: '100%' }}
              name="stockx_product_url"
              id="stockx_product_url"
              value={url}
              onChange={e => setUrl(e.target.value)}
            />
            <br />
          </div>
          <div className="d-flex justify-content-end">
            <Button className="mr-2" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="info"
              onClick={handleSubmitUrl}
            >
              Submit
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SyncStockxIDModal;
